<template>
  <div ref="appRootRef" class="app-container" :data-mode="widgetMode.mode">
    <template v-if="widgetMode.mode === 'search'">
      <SearchWidget @select-country="handleSelect" />
    </template>

    <template v-else>
      <Transition name="slide-left" mode="out-in">
        <HomeView
          v-if="store.currentView === 'home'"
          @select-country="handleSelect"
        />
        <PackagesView
          v-else-if="store.currentView === 'packages'"
          @back="store.HomeStep()"
          @select-package="handleSendPackage"
        />
        <RegisterView
          v-else-if="store.currentView === 'register'"
          @back="store.currentView = 'packages'"
          @back-home="store.HomeStep()"
          @checkout="handleCheckout"
        />
        <CheckoutView
          v-else-if="store.currentView === 'checkout'"
          @back="store.currentView = 'register'"
          @back-packages="store.currentView = 'packages'"
          @back-home="store.HomeStep()"
          @success="handleSuccess"
        />
        <ProfileView
          v-else-if="store.currentView === 'profile'"
          @back="store.HomeStep()"
        />
      </Transition>
    </template>
  </div>
</template>

<script setup lang="ts">
import SearchWidget from '~/components/SearchWidget.vue'
import HomeView from '~/components/HomeView.vue'
import PackagesView from '~/components/PackagesView.vue'
import CheckoutView from '~/components/CheckoutView.vue'
import RegisterView from '~/components/RegisterView.vue'
import ProfileView from '~/components/ProfileView.vue'
import { useStore, useWidgetMode } from '~/composables/widgetMode'
import type { PackageList } from '~/composables/types/esimPackage'
import { watch, nextTick, ref } from 'vue'
import { sleep } from './composables/general'

const store = useStore()
const widgetMode = useWidgetMode()
const appRootRef = ref<HTMLElement | null>(null)

const handleSelect = async (slug: string, name: string) => {
  try {
    await store.PackageStep(slug, name)
  } catch (error) {
    console.error(error)
    store.HomeStep()
  }
}

const handleSendPackage = (pkg: PackageList, count: number) => {
  store.RegisterStep(pkg, count)
}

const handleCheckout = (pkg: PackageList, count: number, email: string) => {
  store.CheckoutStep(pkg, count, email)
}

const handleSuccess = (orderNo: string) => {
  store.ProfileStep(orderNo)
}

watch(() => store.currentView, async () => {
  if (widgetMode.mode !== 'default') return
  await nextTick()
  await sleep(70)
  const el = appRootRef.value?.querySelector<HTMLElement>('[data-focus-view]')
  if (!el) return
  const top = el.getBoundingClientRect().top + window.scrollY - 80
  window.scrollTo({ top, behavior: 'smooth' })
})
</script>

<style scoped>
.app-container {
  width: 100%;
  min-height: auto;
}
</style>